export const zIndexes = {
  backgroundGradient: 10,
  navigation: 201,
  mobileNavigation: 200,
}

export type ThemeColors = keyof typeof zIndexes
